(function($){
  var productsLimitSearch = $('div[data-section-type="search-template"]').data('productsLimit');
  var location = window.location.href;
  var lastUrlSegmentAndQueryParams = location.substring(location.lastIndexOf('/') + 1).split('?');
  var lastUrlSegment = lastUrlSegmentAndQueryParams[0];
  var queryParams = lastUrlSegmentAndQueryParams[1]; 
  var mobileColumns = 2;
  var desktopColumns = 3;
  var columnsDisplayCount = checkIfMobile() ? mobileColumns : desktopColumns;
  var gridStyle = $('div[id$=__search-template] .card-list').data('grid-style') || 'collage';
  var paramsObj = {
        "q": '',
        "type": 'product',
        "page": 1
      };
//   if (lastUrlSegment == "collections") {
  var totalSearchedProducts = [];
  var totalSearchedProductsCount = 0;
  function getProductsBasedOnSearchText(searchedText, page, cursor) {
	//console.log("triggered search === ");
  //console.log("get s_a_t ==> ",  window.storefront_access_token)
	$.ajax({
	  url:	"/api/2022-10/graphql.json",
	  type:	'POST',
      data: JSON.stringify({query: 'query($text: String!) { products(first:250, query:$text) { edges { node { id handle title description onlineStoreUrl tags priceRange { minVariantPrice { amount } maxVariantPrice { amount } } images(first: 5) { edges { node { id originalSrc } } } collections(first: 10) { edges { node { handle } } }} } } }', variables: {"text": searchedText, "cursor": cursor}}),
      headers: {
        "X-Shopify-Storefront-Access-Token": window.storefront_access_token,
        "Content-Type": "application/json"
      }
	})
	.done(function(data) {
     // console.log('====', data);
      totalSearchedProducts = [];
      totalSearchedProducts = totalSearchedProducts.concat(data.data.products.edges);
      totalSearchedProductsCount = totalSearchedProducts && totalSearchedProducts.length ? totalSearchedProducts.length : 0;
      filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, page);
	})
	.fail(function(data) {})
	.always(function(data) {});
  }
  
  function filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, page) {
      var resultsPlaceholder = totalSearchedProductsCount == 1 ? "result" : "results";
      var allProductElements = "";
      var centreClass = "card-list__column--center";
      var filteredProductsByLimitAndPage = totalSearchedProducts.slice((page-1)*productsLimitSearch, ((page-1)*productsLimitSearch) + productsLimitSearch);
      var columnsEleArray = [];
      var columnEleStr = "<div class='card-list__column grid__item  medium-up--one-third small--one-half card-list__column " + (totalSearchedProductsCount == 1 ? centreClass : "") +"'></div>";
      for (var i = 0; i < columnsDisplayCount; i++) {
        columnsEleArray.push($(columnEleStr));
      }
      
      if (lastUrlSegment == "search") {
        allProductElements = $("<div class='card-list grid search-template' data-desktop-columns='3' data-mobile-columns='2' data-grid-style='grid'></div>");
        $(filteredProductsByLimitAndPage).each(function(index){
         // console.log('>>>>>', index);
          var productEle = createSearchTemplateProductsEle(this.node, index, totalSearchedProductsCount);
          columnsEleArray[index%columnsDisplayCount] = columnsEleArray[index%columnsDisplayCount].append($(productEle));
//           allProductElements = allProductElements + productEle;
	    });
        //console.log(totalSearchedProducts);
        var paginationEle = createSearchPaginationEle(totalSearchedProducts, totalSearchedProducts.length, productsLimitSearch, page);
        for (var i = 0; i < columnsDisplayCount; i++) {
          //console.log(columnsEleArray[i].html());
          allProductElements.append(columnsEleArray[i]);
        }
//         allProductElements = allProductElements + "</div>";
        $('div.no-products-text').remove();
//         $('div.card-list').replaceWith($('<div/>').html(allProductElements).contents());
        $('div.card-list').replaceWith(allProductElements);
        if ($('div.card-list__sub-actions') && $('div.card-list__sub-actions').length) {
          $('div.card-list__sub-actions').replaceWith(paginationEle);  
        } else {
          $('div.card-list').after(paginationEle);
        }
        $('.section-header__description').text(totalSearchedProductsCount + " " + resultsPlaceholder);
        $('span.search_results_count').text("Research : " + totalSearchedProductsCount + " " + resultsPlaceholder + " found « " + paramsObj.q + " »");
        if (totalSearchedProductsCount == 0) {
          $('div.card-list').append('<div class="text-center no-products-text"><span>Sorry, no product matches your selection</span></div>');
        }
        if (totalSearchedProductsCount <= productsLimitSearch) {
          $('div.pagination').remove();
        }
        
        allProductElements = "<div class='site-header__search__result__products'>"+
          "<div class='site-header__search__result__title'>"+
              "<h3>"+ totalSearchedProductsCount + " " + resultsPlaceholder + "</h3>"+
          "</div>"+
          "<div class='card-list grid' data-desktop-columns='3' data-mobile-columns='2' data-grid-style='grid'>";
        $(totalSearchedProducts).each(function(index){
          if(index > 2) return false;
          var productEle = createSearchBarPopupProductsEle(this.node, index, totalSearchedProductsCount);
          allProductElements = allProductElements + productEle;
	    });
        //console.log(totalSearchedProducts);
        allProductElements = allProductElements + "</div></div>";
        $('div.no-products-text').remove();
        $('.site-header__search__result__products').replaceWith($('<div/>').html(allProductElements).contents());
        
        // search template cards
        var $cards = $('.search-template .card');
        var $columns = $('.search-template .card-list__column');
        $.each(
		  $cards,
          function (index) {
            var isMobile = checkIfMobile();
            if (isMobile) {
              var rowNumber = (index - (index % mobileColumns)) / mobileColumns + 1;
              matchEleRowHeights($columns, rowNumber);
            } else if (isEleAlignedRow(index + 1, $cards)) {
			  var rowNumber = (index - (index % desktopColumns)) / desktopColumns + 1;
			  matchEleRowHeights($columns, rowNumber);
			}
          }
        )
        
        if (totalSearchedProductsCount == 0) {
          $('div.card-list').append('<div class="text-center no-products-text"><span>Sorry, no product matches your selection</span></div>');
        }
      } else {
        allProductElements = "<div class='site-header__search__result__products'>"+
          "<div class='site-header__search__result__title'>"+
              "<h3>"+ totalSearchedProductsCount + " " + resultsPlaceholder + "</h3>"+
          "</div>"+
          "<div class='card-list grid' data-desktop-columns='3' data-mobile-columns='2' data-grid-style='grid'>";
        $(totalSearchedProducts).each(function(index){
          if(index > 2) return false;
          var productEle = createSearchBarPopupProductsEle(this.node, index, totalSearchedProductsCount);
          allProductElements = allProductElements + productEle;
	    });
        //console.log(totalSearchedProducts);
        allProductElements = allProductElements + "</div></div>";
        $('div.no-products-text').remove();
        $('.site-header__search__result__products').replaceWith($('<div/>').html(allProductElements).contents());
        if (totalSearchedProductsCount == 0) {
          $('div.card-list').append('<div class="text-center no-products-text"><span>Sorry, no product matches your selection</span></div>');
        }
      }
  
  }
    
    function createSearchBarPopupProductsEle(product, index, totalSearchedProductsCount) {
      var productPrice = (parseFloat(product.priceRange.maxVariantPrice.amount) > parseFloat(product.priceRange.minVariantPrice.amount)) ? "À partir de " + parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€" : parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€";
      //console.log(productPrice);
      var borderType = 'bottom';
      var borderIndex = index < 3 ? index : index%3;
      if (borderIndex % 2 != 0) {
        borderType = 'corner'; 
      } 
      
      var productUnitEle = "<div class='card-list__column grid__item  medium-up--one-third'>"+
        "<div class='card critical-clear has-animated card--reveal' id='Card-"+ product.id + "'" + " data-animate>"+
           "<a href='/products/"+ product.handle + "'" + " class='card__wrapper text-center' data-tabindex='1'>"+
                                "<div class='card__image-wrapper card__image-wrapper--aligned'>"+
                                  "<img class='card__image card__image--align fade-in lazyautosizes lazyloaded' "+
                                   "src='" + product.images.edges[0].node.originalSrc + "'" +
                                   "data-parent-fit='cover'"+
                                   "data-widths='[900, 1080, 1296, 1512, 1728, 2048]'"+
                                   "data-aspectratio='0.6'"+
                                   "loading='lazy'"+
                                   "data-sizes='auto'>"+
                                  "<div class='card__preloader'></div>"+
                                "</div>"+
                                "<div class='card__info card__info--aligned'>"+
                                  "<h3 class='card__name h4'>"+ product.title + "</h3>"+
                            
                                "</div>"+
                            "</a>"+
                          "</div>"+
      "</div>";
      
      
      
      
      
    return productUnitEle;
  }

  function createSearchTemplateProductsEle(product, index, totalSearchedProductsCount) {
    var productPrice = (parseFloat(product.priceRange.maxVariantPrice.amount) > parseFloat(product.priceRange.minVariantPrice.amount)) ? "À partir de " + parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€" : parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€";
    //console.log(productPrice);
    var borderType = 'border-right';
    var borderIndex = index < 3 ? index : index%3;
    if (borderIndex % 2 != 0) {
      borderType = 'no-border-right'; 
    }
    var tabIndex = index + 1;
    var priceUnitEle = "<div class='card critical-clear card--reveal' id='Card-"+ product.id + "'" + " data-animate>"+
  "<a href='/products/"+ product.handle + "'" + " class='card__wrapper text-center' data-tabindex='"+ tabIndex +"'>"+

    "<div class='card__image-wrapper card__image-wrapper--aligned'>"+
    "<img class='card__image card__image--align fade-in lazyautosizes ls-is-cached lazyloaded'"+
      "src='" + product.images.edges[0].node.originalSrc + "'" +
      "data-parent-fit='cover'"+
      "data-widths='[900, 1080, 1296, 1512, 1728, 2048]'"+
      "data-aspectratio='0.5994277539341917'"+
      "data-sizes='auto'>"+
    "<div class='card__preloader'></div>"+
  "</div>"+
    "<div class='card__info'>"+
      "<h3 class='card__name h4'>" + product.title + "</h3>"+
        
    "</div>"+
  "</a>"+
"</div>";
    return priceUnitEle;
  
  }
  
    function createSearchPaginationEle(totalSearchedProducts, totalSearchedProductsCount, limitPageCount, currentPage) {
    var totalPages = Math.ceil(totalSearchedProductsCount/limitPageCount);
    var paginationEle = '';
    var previousPageEle = '';
    var pagesCountEle = '';
    var nextPageEle = '';
    //console.log(totalPages);
    //console.log(currentPage);
    if (totalPages && totalPages >= 1) {
      paginationEle = "<div class='pagination'>"+
        "</div>";
      if (currentPage == 1) {
        previousPageEle = $("<button class='btn--secondary pagination__btn pagination__btn--previous' disabled=''>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-left' viewBox='0 0 4 7'><path fill='#444' d='M0 3.5L4 0v7L0 3.5z'></path></svg>"+
        "<span class='icon__fallback-text'>Précédent</span>"+
        "</button>");
      } else {
        previousPageEle = $("<a href='#' class='btn--secondary pagination__btn pagination__btn--previous'>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-left' viewBox='0 0 4 7'><path fill='#444' d='M0 3.5L4 0v7L0 3.5z'></path></svg>"+
        "<span class='icon__fallback-text'>Précédent</span>"+
        "</a>");
        previousPageEle.click(function(ev){
          ev.preventDefault(); // prevent default click handler on "a"
          var queryParams = '';
          paramsObj.page = currentPage - 1;
          if (paramsObj.q) {
            queryParams = queryParams ? queryParams + '&q='+paramsObj.q : '?q='+paramsObj.q;
          }
          if (paramsObj.page) {
            queryParams = queryParams ? queryParams + '&page='+paramsObj.page : '?page='+paramsObj.page;
          }
          queryParams = queryParams ? queryParams + '&type=product' : '?type=product';
          window.history.replaceState(null, null, queryParams);
          filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, currentPage - 1);
        });
      }
      if (currentPage == totalPages) {
        nextPageEle = $("<button class='btn--secondary pagination__btn pagination__btn--next' disabled=''>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-right' viewBox='0 0 4 7'><path fill='#444' d='M4 3.5L0 7V0z'></path></svg>"+
        "<span class='icon__fallback-text'>Suivant</span>"+
        "</button>");
      } else {
        nextPageEle = $("<a href='#' class='btn--secondary pagination__btn pagination__btn--next'>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-right' viewBox='0 0 4 7'><path fill='#444' d='M4 3.5L0 7V0z'></path></svg>"+
        "<span class='icon__fallback-text'>Suivant</span>"+
        "</a>");
        nextPageEle.click(function(ev){
          ev.preventDefault(); // prevent default click handler on "a"
          var queryParams = '';
          paramsObj.page = currentPage + 1;
          if (paramsObj.q) {
            queryParams = queryParams ? queryParams + '&q='+paramsObj.q : '?q='+paramsObj.q;
          }
          if (paramsObj.page) {
            queryParams = queryParams ? queryParams + '&page='+paramsObj.page : '?page='+paramsObj.page;
          }
          queryParams = queryParams ? queryParams + '&type=product' : '?type=product';
          window.history.replaceState(null, null, queryParams);
          filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, currentPage + 1);
        });
      }
//       previousPageEle = $('<div/>').html(previousPageEle).contents();
//       nextPageEle = $('<div/>').html(nextPageEle).contents();
      var i;
      for(i = 1; i <= totalPages; i++) {
        if (currentPage == i) {
          pagesCountEle = pagesCountEle ? pagesCountEle.append("<span class='pagination__page pagination__page--current spin'>"+ i + "</span>") : $('<div/>').html("<div class='pagination__pages'></div>").contents().append("<span class='pagination__page pagination__page--current spin'>"+ i + "</span>");
        } else {
          var ele = $("<a href='#' class='pagination__page'>"+ i +"</a>");
          ele.click(function(ev){
            ev.preventDefault(); // prevent default click handler on "a"
            var queryParams = '';
            paramsObj.page = parseInt($(this).text());
            if (paramsObj.q) {
              queryParams = queryParams ? queryParams + '&q='+paramsObj.q : '?q='+paramsObj.q;
            }
            if (paramsObj.page) {
              queryParams = queryParams ? queryParams + '&page='+paramsObj.page : '?page='+paramsObj.page;
            }
            queryParams = queryParams ? queryParams + '&type=product' : '?type=product';
            window.history.replaceState(null, null, queryParams);
            filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, parseInt($(this).text()));
          });
          pagesCountEle = pagesCountEle ? pagesCountEle.append(ele) : $('<div/>').html("<div class='pagination__pages'></div>").contents().append(ele);
        }
      }
//     paginationEle = paginationEle + previousPageEle + "<div class='pagination__pages'>"+ pagesCountEle + "</div>" + nextPageEle + "</div></div>";
      paginationEle = $("<div class='card-list__sub-actions card-list__sub-actions--loaded'></div>").append($(paginationEle).append(previousPageEle).append(pagesCountEle).append(nextPageEle));
    }
    return paginationEle;
  }
  
  
    $('.site-header__search__inner').on('keyup change cut paste','.input-group__field', function () {
      var text = $(this).val();
//       if (text && text.length >=3) {
        getProductsBasedOnSearchText(text, 1);
//       }
    } );
//   }
  
  if (lastUrlSegment == "search") {
    if (queryParams) {
        var jsonParamsArray = JSON.parse(JSON.stringify('{"' + queryParams.replace(/&/g, '"},{"').replace(/=/g,'":"') + '"}')).split(',');
        $(jsonParamsArray).each(function(index, stringObj) {
          var obj = JSON.parse(stringObj);
          for (const [key, value] of Object.entries(obj)) {
            //console.log(`${key}: ${value}`);
            if (key == "page") {
              paramsObj[key] = parseInt(value);
            } 
            if (key == "q" || key == "type") {
              paramsObj[key] = value;
            }
          }
        })
    }
    getProductsBasedOnSearchText(paramsObj.q, paramsObj.page);
    $('.search-template__search-bar').on('keyup change cut paste','.input-group__field', function () {
      var queryParams = '';
      var text = $(this).val();
//       if (text && text.length) {

        if( $(this).val().length != 0 ) {
          getProductsBasedOnSearchText(text, 1);
          queryParams = queryParams ? queryParams + '&q='+text : '?q='+text;
          paramsObj.q = text;
          if (paramsObj.page) {
            queryParams = queryParams ? queryParams + '&page='+paramsObj.page : '?page='+paramsObj.page;
          }
          queryParams = queryParams ? queryParams + '&type=product' : '?type=product';
          window.history.replaceState(null, null, queryParams);
      }
//       }
    } );
  } else {
    getProductsBasedOnSearchText(queryParams, 1);
  }
  
  function checkIfMobile() {
	var status = $(window).outerWidth() < theme.mediaQuerySmall;
	return status;
  }
  
  function matchEleRowHeights ($columns, rowNumber) {
			var maxHeight = 0;
			var currentCardHeight = 0;
			var rowSelector = '';
			var isArticle = false;

			// Construct the selector for the cards in the current row
			for (var i = 0; i < $columns.length; i++) {
				rowSelector +=
					"[data-tabindex='" +
					((rowNumber - 1) * $columns.length + i + 1) +
					"']";
				if (i < $columns.length - 1) {
					rowSelector += ', ';
				}
			}
			var $row = $columns.find(rowSelector).parent();

			for (var j = 0; j < $row.length; j++) {
				isArticle = $($row[j])
					.find('.card__wrapper')
					.is('.card--article');

				currentCardHeight = $($row[j])
					.find('.card__wrapper')
					.outerWidth();
				if ($(document.body).hasClass('template-search') && isArticle) {
					currentCardHeight = $($row[j])
						.find('.card__wrapper')
						.outerHeight();
				} else {
					currentCardHeight =
						$($row[j]).find('.card__wrapper').outerWidth() +
						$($row[j]).find('.card__info').outerHeight();
				}

				if (currentCardHeight > maxHeight) {
					maxHeight = currentCardHeight;
				}
			}

			$row.find('.card__wrapper').outerHeight(maxHeight);
		}
  
        function isEleAlignedRow (index, $cards) {
			// Check if the gridStyle is 'grid', and if we are at the end of a row or
			// at the last card
			return (
			    gridStyle === 'grid' &&
				(index % desktopColumns === 0 || index === $cards.length)
			);
		}
  
   $(window).resize(function() {
     var isMobile = checkIfMobile();
     columnsDisplayCount = isMobile ? mobileColumns : desktopColumns;
     if (lastUrlSegment == "search") {
       filterSearchedProducts(totalSearchedProducts, totalSearchedProductsCount, paramsObj.page);
     } 
   });
  
})(jQuery);  